export default function convertNumberToLetter(number) {
    let result = '';
    while (number >= 0) {
      result = String.fromCharCode(number % 26 + 65) + result;
      number = Math.floor(number / 26) - 1;
    }
    return result;
  }